import React, { FC } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { InvoiceApi, OrderInvoiceApi } from "../../../../../../../../services/Api/Organization/types";
import { exportInvoicePdf, exportInvoicesPdf } from "../../services/exportInvoice";

interface Props {
	isShown: boolean;
	onHide: () => void;
	invoices: (InvoiceApi | OrderInvoiceApi)[];
	onSuccessAction: () => void;
	params?: Record<string, any>;
}

const ExportInvoiceConfirmationModal: FC<Props> = ({ isShown, onHide, invoices, onSuccessAction, params }) => {
	const { t } = useTranslation();

	const onSubmit = async () => {
		if (invoices.length > 1) {
			await exportInvoicesPdf(invoices, t, params);
		} else {
			await exportInvoicePdf(invoices[0], t);
		}
		onSuccessAction();
		onHide();
	};

	return (
		<Modal onHide={onHide} show={isShown}>
			<Modal.Header closeButton>
				<Modal.Title>{t("lib:confirmation.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="warning">{t("modules.invoice.field.confirm_export_invoice_to_pdf.title")}</Alert>
			</Modal.Body>
			<Modal.Footer>
				<Button type="submit" onClick={onSubmit}>
					{t("common.action.export_to_pdf")}
				</Button>
				<Button variant="light" onClick={onHide}>
					{t("lib:common.action.cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ExportInvoiceConfirmationModal;
